/*
 * PilotMall list clicks for GA4 (select_item). Added 2026-10-10 (Neil: "list-click recording. please fix").
 *
 * GA4 runs in the "PilotMall Unified" custom pixel (Settings > Customer events), which sees only Shopify's
 * standard events, and Shopify has no standard event for "clicked a product in a list". So the theme hands the
 * click to the pixel as a custom event, pm_select_item, and the pixel sends select_item with the same client and
 * session ids as its view_item_list and view_item.
 *
 * Timing: a click on a product card leaves the page at once, before the pixel sandbox could finish a send. So the
 * click is only noted here (localStorage, so a card opened in a new tab works too), and the product page it leads
 * to publishes it. Nothing ever delays or blocks the click.
 *
 * Data: each card carries data-pm-item (snippets/card-product.liquid); collection and search grids carry
 * data-pm-list-id, data-pm-list-name and data-pm-offset (the page offset), so index is the position shoppers saw,
 * counting earlier pages. Cards in other sections (featured collections, recommendations) use the section id and
 * its heading.
 */
(function () {
  'use strict';
  var KEY = 'pm_select_item';
  var MAX_AGE = 120000;            // a click older than 2 minutes is not the reason for this product view

  function productHandle(path) {
    var m = String(path || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function listOf(card) {
    var list = card.closest('[data-pm-list-id]');
    var scope, id, name, offset = 0;
    if (list) {
      scope = list;
      id = list.getAttribute('data-pm-list-id');
      name = list.getAttribute('data-pm-list-name');
      offset = parseInt(list.getAttribute('data-pm-offset') || '0', 10) || 0;
    } else {
      var section = card.closest('.shopify-section');
      scope = section || document.body;
      id = section ? section.id.replace(/^shopify-section-/, '').replace(/^.*__/, '') : 'page';
      var heading = scope.querySelector('h2, .title, h3');
      name = heading ? heading.textContent.replace(/\s+/g, ' ').trim().slice(0, 100) : 'Products';
    }
    var cards = Array.prototype.slice.call(scope.querySelectorAll('product-card[data-pm-item]'));
    return { id: id, name: name, index: offset + cards.indexOf(card) + 1 };
  }

  function note(event) {
    try {
      if (event.type === 'auxclick' && event.button !== 1) return;
      var link = event.target.closest && event.target.closest('a[href*="/products/"]');
      if (!link) return;
      var card = link.closest('product-card[data-pm-item]');
      if (!card) return;
      var item = JSON.parse(card.getAttribute('data-pm-item'));
      var list = listOf(card);
      item.index = list.index;
      item.item_list_id = list.id;
      item.item_list_name = list.name;
      localStorage.setItem(KEY, JSON.stringify({
        handle: productHandle(link.pathname),
        at: Date.now(),
        data: { item_list_id: list.id, item_list_name: list.name, items: [item] }
      }));
    } catch (e) { /* tracking must never break a click */ }
  }

  function publish(data, triesLeft) {
    var a = window.Shopify && window.Shopify.analytics;
    if (a && typeof a.publish === 'function') {
      try { a.publish('pm_select_item', data); } catch (e) { /* ignore */ }
      return;
    }
    if (triesLeft > 0) setTimeout(function () { publish(data, triesLeft - 1); }, 250);
  }

  function flush() {
    var here = productHandle(location.pathname);
    if (!here) return;                // only a product page consumes a noted click
    var rec;
    try {
      rec = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (!rec) return;
      localStorage.removeItem(KEY);
    } catch (e) { return; }
    if (rec.handle !== here || !rec.at || Date.now() - rec.at > MAX_AGE) return;
    publish(rec.data, 40);            // up to 10 seconds for the Web Pixels Manager to be ready
  }

  document.addEventListener('click', note, true);
  document.addEventListener('auxclick', note, true);
  flush();
})();
